<template>
  <div id="app">
    <router-view />
    <notifications group="user" position="top right" />
  </div>
</template>

<script>
export default {
  components: {
    "c-page-loader": resolve => import("./components/pageLoader")
  },
  data() {
    return {
      userStatus: false
    };
  },
  computed: {
    logged() {
      return this.$cookies.isKey("user-token");
    },
    loadData() {
      return this.$store.getters.getData;
    }
  },
  methods: {
    getData() {
      const success = response => {
        this.$store.commit("setLsList", response.data.accounts);
        this.$store.commit("setUser", response.data.personal_info);
        this.$store.commit("setAccountNumber",  response.data.account_number);
        this.$store.commit("setEverokToken",  response.data.everok_token);
      };
      const error = response => {
        this.showNtf("Important message", "Something went wrong!", "error");
      };
      this.useRpc("account.get_accounts", {}, success, error);
      if (this.loadData) this.$store.commit("setGetData", false);
     
    }
  },
  watch: {
    loadData() {
      if (this.loadData) {
        this.getData();
      }
    }
  },
  beforeMount() {
    this.getData();
  },
  updated() {
    if (!this.logged) {
      this.getData();
    }
  }
};
</script>

<style lang="scss">
body {
  padding: 0;
  margin: 0;
  background: linear-gradient(135deg, #92bdff 0%, #e3e6ff 50%, #efe7ff 100%) ;
  background-attachment: fixed !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
}

* {
  box-sizing: border-box;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.custom-input {
  background: rgba(0, 0, 0, 0.24) !important;
  border: unset !important;

  &:disabled {
    color: #adadad !important;
  }

  &::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: #d1d1d1 !important;
  }

  &::-moz-placeholder {
    /* Firefox 19+ */
    color: #d1d1d1 !important;
  }

  &:-ms-input-placeholder {
    /* IE 10+ */
    color: #d1d1d1 !important;
  }

  &:-moz-placeholder {
    /* Firefox 18- */
    color: #d1d1d1 !important;
  }
}

.custom-input-group {
  .input-group-prepend {
    .input-group-text {
      background: rgba(0, 0, 0, 0.4);
      color: #fff;
      border: unset;
    }
  }
}

.card {
  background: #fff !important;
  border-radius: 0.5rem !important;
  -webkit-box-shadow: 0 23px 20px -20px rgba(6, 8, 10, 0.1),
    0 0 15px rgba(6, 8, 10, 0.06) !important;
  box-shadow: 0 23px 20px -20px rgba(6, 8, 10, 0.1),
    0 0 15px rgba(6, 8, 10, 0.06) !important;
}
</style>
